import React from 'react';
import { useTranslation } from 'react-i18next';

import TablesToggle from '../../../shared-components/tables-toggle/TablesToggle';

import AccountListPenalty from './Overrides/PenaltyAccountList';
import StationListPenalty from './Overrides/PenaltyStationList';

/**
 * Override List Pages
 */
function OverrideListPages() {
  const { t } = useTranslation('penaltyManagement');

  return (
    <div className="override-list-view">
      <TablesToggle
        tabs={[
          { label: t('accounts'), content: <AccountListPenalty /> },
          { label: t('stations'), content: <StationListPenalty /> },
        ]}
      />
    </div>
  );
}

export default OverrideListPages;
